import React, { useState, useRef } from "react";

export function FeatureSlider() {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    name: "",
    city: "",
    jobRole: "",
    cv: null
  });
  const [submitted, setSubmitted] = useState(false);
  const fileInputRef = useRef(null);

  function handleInputChange(e) {
    const { name, value, files } = e.target;
    if (name === "cv") {
      setForm(prev => ({ ...prev, cv: files[0] }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    // You could send form here to backend
    setSubmitted(true);
    setTimeout(() => {
      setShowModal(false);
      setSubmitted(false);
      setForm({ name: "", city: "", jobRole: "", cv: null });
      if (fileInputRef.current) fileInputRef.current.value = "";
    }, 2000);
  }

  function handleClose() {
    setShowModal(false);
    setSubmitted(false);
    setForm({ name: "", city: "", jobRole: "", cv: null });
    if (fileInputRef.current) fileInputRef.current.value = "";
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 ">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <img
            src="/Images/img4.jpeg"
            className="w-full h-[450px] object-cover"
            alt="Team collaboration"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50" />

          {/* Content */}
          <div className="absolute inset-0 flex flex-col justify-center px-8  sm:px-12 text-white max-w-6xl">
            <span className="border border-white/60 rounded-full px-4 py-1 text-xs w-fit mb-4 tracking-wider font-semibold bg-white/10">
              OUR TEAM, OUR STRENGTH
            </span>

            <h3 className="text-3xl md:text-4xl font-bold leading-tight mb-4 font-serif">
              We believe in empowering talent, fostering innovation,<br className="hidden md:inline" /> and creating endless opportunities.
            </h3>

            <p className="mt-2 text-white/80 text-base md:text-lg leading-relaxed">
              Whether you’re starting your journey or taking the next big step in your career, we offer an environment where learning, collaboration, and excellence thrive.
            </p>
            <p className="mt-2 text-white/90 text-lg md:text-xl font-semibold italic">
              Your growth fuels <span className="text-[#0393da] not-italic">our success.</span>
            </p>
            <p className="mt-2 text-white/80 text-base md:text-lg">
              Join us and be part of something extraordinary.
            </p>

            <button
              className="mt-4 bg-[#0393da] hover:bg-blue-600 px-7 py-3 rounded-full w-fit font-semibold text-base shadow-md transition"
              onClick={() => setShowModal(true)}
              type="button"
            >
              Join Our Team
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 transition-all">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-8 relative z-10 mx-2">
            <button
              className="absolute top-2 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold"
              onClick={handleClose}
              aria-label="Close"
              type="button"
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold mb-4 text-[#0393da] font-serif">Apply to Join Our Team</h2>
            {submitted ? (
              <div className="text-center text-green-600 font-semibold my-8">
                Thank you! Your application has been submitted.
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div>
                  <label htmlFor="name" className="block font-semibold text-gray-700 mb-1">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-[#0393da] text-gray-900"
                    value={form.name}
                    onChange={handleInputChange}
                    placeholder="Your Name"
                  />
                </div>
                <div>
                  <label htmlFor="city" className="block font-semibold text-gray-700 mb-1">
                    City <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="city"
                    name="city"
                    type="text"
                    required
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-[#0393da] text-gray-900"
                    value={form.city}
                    onChange={handleInputChange}
                    placeholder="City"
                  />
                </div>
                <div>
                  <label htmlFor="jobRole" className="block font-semibold text-gray-700 mb-1">
                    Job Role <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="jobRole"
                    name="jobRole"
                    type="text"
                    required
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-[#0393da] text-gray-900"
                    value={form.jobRole}
                    onChange={handleInputChange}
                    placeholder="Desired Job Role"
                  />
                </div>
                <div>
                  <label htmlFor="cv" className="block font-semibold text-gray-700 mb-1">
                    CV/Resume <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="cv"
                    name="cv"
                    type="file"
                    required
                    className="w-full"
                    accept=".pdf,.doc,.docx"
                    onChange={handleInputChange}
                    ref={fileInputRef}
                  />
                </div>
                <button
                  className="mt-2 bg-[#0393da] hover:bg-blue-700 text-white font-semibold rounded-full px-5 py-2 transition w-full"
                  type="submit"
                >
                  Submit Application
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </section>
  );
}